'use strict';
import * as T from 'prop-types';
import React from 'react';
import {Button} from '../../../components/buttons/Button';
import {Modal} from '../../../components/modals/Modal';
import {ModalContent} from '../../../components/modals/ModalContent';
import {ModalFooter} from '../../../components/modals/ModalFooter';
import {ModalHeader} from '../../../components/modals/ModalHeader';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {I18nComponent} from '../../../core-utilities/react-i18n';


export const modalOptions = {
  isLegacy: true,
};

export function BaseVideoCallStartModalView(props) {
  return (
    <Modal className={props.className}>
      <ModalHeader modalHeaderLabel={props.headerLabel} />
      <ModalContent className="VideoCallStartModal">
        <div className="VideoCallStartModal__subHeader">
          <span>
            {props.subHeaderLabel}
          </span>
          <Button
            className="VideoCallStartModal__addButton"
            disabled={props.disableAddUser}
            label={props.addUserLabel}
            onClick={props.onSelectUser}
          />
        </div>
        <div className="VideoCallStartModal__selected">
          {props.selected.map(model => (
            <div
              key={getId(model)}
              className="VideoCallStartModal__person"
            >
              <span>
                {model.name}
              </span>
              <Button
                className="VideoCallStartModal__removeButton"
                iconClass="icon ion-close"
                useArrayArgs={true}
                bindParam={model}
                onClick={props.onRemoveSelected}
              />
            </div>
          ))}
        </div>
      </ModalContent>
      <ModalFooter>
        <Button
          className="FormModal__cancelButton"
          label={props.cancelButtonLabel}
          onClick={props.onCancel}
        />
        <Button
          className="VideoCallStartModal__startCallButton"
          disabled={props.disableStartCall}
          label={props.startCallButtonLabel}
          onClick={props.onStartCall}
        />
      </ModalFooter>
    </Modal>
  );
}

BaseVideoCallStartModalView.propTypes = {
  className: T.string,
  disableAddUser: T.bool,
  selected: T.array,

  headerLabel: T.string,
  subHeaderLabel: T.string,
  addUserLabel: T.string,
  startCallButtonLabel: T.string,
  cancelButtonLabel: T.string,
};

BaseVideoCallStartModalView.defaultProps = {
  className: '',
};

export const VideoCallStartModalView = I18nComponent(BaseVideoCallStartModalView, [
  {code: 'video.chat.invite.header', prop: 'headerLabel'},
  {code: 'video.chat.invite.message', prop: 'subHeaderLabel'},
  {code: 'video.chat.invite.add.label', prop: 'addUserLabel'},
  {code: 'video.chat.call.start.label', prop: 'startCallButtonLabel'},
  {code: 'default.cancel.label', prop: 'cancelButtonLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/comments/components/VideoCallStartModal/VideoCallStartModalView.js